import React, { useEffect } from 'react';
import SeoHelmet from "../components/SeoHelmet";
const Thankyou = () => {

    
  return (

    <>
    
    <SeoHelmet /> 
   <div className='container'>
    <div className='thank'>
      <h1>Thank You!</h1>
      <p>Your message has been sent successfully. We will get back to you soon!</p>
      <a href="/">Return to Home</a>
    </div>
   </div>

</>



  );
};

export default Thankyou;
